import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      {...props}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M11.999 19.68a9.12 9.12 0 100-18.24 9.12 9.12 0 000 18.24z"
        fill="#fff"
      />
      <Path
        d="M12.017 16.354a5.777 5.777 0 100-11.554 5.777 5.777 0 000 11.554z"
        fill="#222"
      />
      <Path
        d="M18.788 3.772A9.537 9.537 0 0011.999.96a9.537 9.537 0 00-6.788 2.812A9.537 9.537 0 002.4 10.56a9.604 9.604 0 007.557 9.381l2.043 2.725 2.044-2.725A9.603 9.603 0 0021.6 10.56a9.537 9.537 0 00-2.811-6.788zm-6.789-.306a7.06 7.06 0 017.052 7.051 7.06 7.06 0 01-7.052 7.052 7.06 7.06 0 01-7.05-7.051 7.06 7.06 0 017.05-7.052z"
        fill="#222"
      />
    </Svg>
  );
}

export default SvgComponent;
